var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"partner_11"},[_c('h3',[_vm._v("合作伙伴")]),_c('div',{directives:[{name:"bg",rawName:"v-bg"}],staticClass:"partner_list_11",attrs:{"bg-url":require("@/plan/assets/image/11/partner.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }